import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/fund?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/fund', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/fund/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/fund/${body.id}`, body.body);
};